export default __webpack_public_path__ + "static/media/eolt_logo_white.5142cef3.svg";